<template>
  <v-icon :color="iconColor(value)">{{iconSimbol(value)}}</v-icon>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  methods: {
    iconColor (value) {
      return value ? 'green' : 'red'
    },
    iconSimbol (value) {
      return value ? 'mdi-check' : 'mdi-close'
    }
  }
}
</script>
